<template>
  <div class="query">
    <!-- 轮播图 -->
    <div class="vant-swipe" style="margin: 0; padding: 0;">
        <van-swipe :loop="true" :show-indicators="true" :autoplay="5000" style="height:188px;" indicator-color="white">
            <van-swipe-item v-for="(image,index) in images" :key="image.id">
                <img v-lazy="image.img"  style="width: 100%; height: 188px;"/>
            </van-swipe-item>
        </van-swipe>
    </div>

    <!--搜索-->
    <van-cell label="输入姓名无反应，请核对姓名或确认是否已捐款。">
      <template slot="title">
        <span style="font-size: 18px;">共捐款金额：{{ totalMoney() }}元</span>
      </template>
    </van-cell>
    <van-search v-model="searchQuery" placeholder="请输入捐款人姓名查询" />

    <!--列表-->
    <div style="height: 10px;"></div>

     <template v-for="item in filterItems()" v-if="searchQuery">
        <van-cell-group>
          <van-cell :label="item.address" :value="item.money+'元'" is-link :to="'/donation/detail?id='+item.id">
            <template slot="title">
              <span class="custom-text" style="padding-right:10px;">{{item.name}}</span>
              <van-tag plain type="danger" v-if="item.village">{{item.village}}</van-tag>
            </template>
          </van-cell>
        </van-cell-group>
     </template>

     <!-- 底部导航 -->
     <div class="tab-bar">
       <van-tabbar v-model="active">
         <van-tabbar-item icon="home-o" url="https://work.weixin.qq.com/kfid/kfcfbbe2c2365f1a8e9">联系客服</van-tabbar-item>
       </van-tabbar>
     </div>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'

export default {
    'name': 'Donation',
    data() {
        return {
          images: [
              {id:1,img: require('../../../public/static/tb2.jpg')}
          ],
          searchQuery:'',
          active:''
        };
    },
    computed: {
       ...mapState({
            list: state => state.root.donation_list
       })
    },
    methods: {
        ...mapActions(['requestDonation']),
        filterItems() {
          const query = this.searchQuery.toLowerCase()
          if(this.list) {
            return this.list.filter(item => item.name === this.searchQuery)
          }
        },
        totalMoney() {
           if(this.list) {
             return this.list.reduce((sum, item) => {
               return sum + Number(item.money)
             }, 0)
           }else{
             return 0;
           }
        }
    },
    components: {

    },
    mounted() {
      this.requestDonation({"thit":this});
    }
};
</script>

<style scoped>
.query >>> .van-nav-bar {
  z-index: 9;
  background-color: #ed3f2c;
  padding-top: 6px;
}
.query >>> .van-nav-bar__text {
  color: #fff;
}
.query >>> .van-nav-bar__title {
  color: #fff;
}
.query >>> .van-nav-bar .van-icon {
  color: #fff;
}
.query >>> .van-button--primary {
  color: #fff;
  background-color: #ed3f2c;
  border: 0.02667rem solid #ed3f2c;
}
</style>
